import React, {useEffect, useMemo, useState} from "react";
import FormControl from "@material-ui/core/FormControl";
import {Editor} from "react-draft-wysiwyg";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import connection from "../connection";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileDownload} from "@fortawesome/free-solid-svg-icons";
import {ContentState, convertFromHTML, convertToRaw, EditorState} from "draft-js";
import {draftToMarkdown} from 'markdown-draft-js';

export default function SeccaoRelatorio({titulo, instrucoes, dados, classes}) {

  let editorState = useMemo(() => {
    if (dados.texto)
      return EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(dados.texto.split("\n").join("<br/>"))));
    return EditorState.createEmpty();
  }, []);

  let editorSetMessage = (es) => {
    dados.texto = draftToMarkdown(convertToRaw(es.getCurrentContent()));
  };

  const [anexo, setAnexo] = useState(dados.anexo);

  useEffect(() => {
    dados.anexo = anexo;
  }, [anexo])

  return <>
    <h4>{titulo}</h4>
    <p>{instrucoes}</p>
    <FormControl fullWidth className={classes.selectFormControl}>
      <div style={{
        background: "#fbfbfb",
        padding: 5,
        borderRadius: 5
      }}>
        <Editor
          defaultEditorState={editorState}
          wrapperClassName="wrapper-class"
          editorClassName={"editor-class " + classes.mensagemEditor}
          toolbarClassName={"toolbar-class " + classes.mensagemToolbar}
          onEditorStateChange={(es) => {
            editorState = es;
            editorSetMessage(es);
          }}
          toolbar={{
            options: ['inline'],
            inline: {
              options: ['bold', 'italic', 'underline']
            },
            history: {
              options: ['undo', 'redo']
            }
          }}/>
      </div>
    </FormControl>
    <CustomInput
      labelProps={{
        shrink: true
      }}
      labelText={<span>
        Anexo (opcional) {anexo && <>
        {anexo.path && <a target="_blank" href={connection.getFullUrl(anexo.path)}> {anexo.informacoes_ficheiro?.name} <FontAwesomeIcon icon={faFileDownload}/></a>}
        <span onClick={() => {
          setAnexo(null);
        }}> (remover)</span>
      </>}
    </span>}
      formControlProps={{
        fullWidth: true
      }}
      inputProps={{
        value: anexo?.name ? undefined : '',
        type: "file",
        onChange: (e) => {
          if (e.target.files.length > 0)
            setAnexo(e.target.files[0]);
        },
        accept: "application/pdf"
      }}
    />
  </>;
}